export default {
  appName: process.env.VUE_APP_GOOGLE_ANALITYCS_NAME, // Mandatory
  appVersion: process.env.PACKAGE_VERSION || '0', // Mandatory
  trackingId: process.env.VUE_APP_GOOGLE_ANALITYCS_UA, // Mandatory
  debug: process.env.NODE_ENV !== 'production' // Whether or not display console logs debugs (optional)
}
